import { useEffect } from 'react'
import { useNavigate } from 'react-router'

import B2bLoadingFullPage from '@/components/B2bLoadingFullPage'
import { useAppDispatch } from '@/store/hook'
import { authenticationActions } from '@/store/slices/authenticationSlice'
import { getInfoFromUrl } from '@/libs/utils/punchoutHandler'
import { safeDecodeURIComponent } from '@/libs/utils/safeDecoding'

export default function TechnicalLoginPage() {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  useEffect(() => {
    const { pathname = '' } = globalThis.location ?? {}

    const pathParts = pathname.split('/')
    // Get the last part of the path
    const encodedSecrets = pathParts.at(-1)
    // Remove the first character of the encoded string
    const trimmedEncodedSecrets = encodedSecrets.slice(1)
    const decodedSecrets = globalThis.atob(trimmedEncodedSecrets)

    const queryKeys = ['username', 'password']
    const punchoutType = pathParts.at(-2)

    const punchout = getInfoFromUrl(decodedSecrets, queryKeys, {
      type: punchoutType,
    })

    dispatch(
      authenticationActions.signIn({
        username: safeDecodeURIComponent(punchout?.username || ''),
        password: safeDecodeURIComponent(punchout?.password || ''),
        navigate,
      }),
    )
  }, [navigate, dispatch])

  return <B2bLoadingFullPage />
}
